<div
  class="status-tracking-wrapper"
  [class.with-map]="enableMapView"
  *ngIf="orderDetails"
  #statusTrackingWrapper
  [class.full-screen]="fullScreen">
  <div class="status-tracking-relative-wrapper" #statusRelativeTrackingWrapper>
    <common-close-icon
      *ngIf="fullScreen"
      class="close-icon"
      backgroundColor="#FFFFFF"
      strokeColor="#7A89AD"
      trackable="Tracking Page/{{ orderDetails.customerTrackingStatus }}/Expanded Map closed"
      (click)="toggleCardFullScreen.emit(false)" />
    <common-map
      #mapComponent
      *ngIf="enableMapView"
      [fitBoundsToAllMarkers]="true"
      [mapMarkers]="mapMarkers"
      [boundsPadding]="mapBoundsPadding"
      (mapClick)="toggleCardFullScreen.emit(true)"
      class="map"></common-map>
    <div class="order-status-container" [class.float-on-map]="enableMapView" #orderStatusContainer>
      <common-order-status
        class="order-status"
        [contained]="contained"
        [showRebookButton]="showRebookButton"
        [disableRebookButton]="disableRebookButton"
        [commitedDropoffTime]="communicatedDropoffInfoText"
        [isAdmin]="isAdmin"
        [orderDetails]="orderDetails"
        [status]="status"
        [shouldShowEditButtonForMerchant]="shouldShowEditButtonForMerchant"
        [isGreen]="orderDetails.isGreen"
        [externalOrderId]="externalOrderId"
        [isExternalPickup]="orderDetails.isExternalPickup && orderDetails.originAddress.type !== AddressType.Pudo"
        [dropoffStart]="dropoffStart"
        [dropoffEnd]="dropoffEnd"
        [dropoffEta]="dropoffEta"
        [dropoffWindowType]="orderDetails.trackingInfo.dropoffWindowType"
        [statusUpdateTime]="orderDetails.statusUpdateTime"
        [addressLine1]="addressLine1"
        [addressLine2]="addressLine2"
        [merchantEmail]="merchantEmail"
        [merchantPhone]="merchantPhone"
        [merchantName]="merchantName"
        [merchantOffset]="merchantOffset"
        [brandColor]="brandColor"
        [textColor]="textColor"
        [chatAllowed]="chatAllowed"
        [courierName]="orderDetails.trackingInfo.courierName"
        [courierPhone]="orderDetails.trackingInfo.courierPhone"
        [vehicleType]="orderDetails.trackingInfo.vehicleType"
        [shouldShowContactDriverMessage]="shouldShowContactDriverMessage"
        [nativeTrackingUrl]="nativeTrackingUrl"
        [editCtaFontWeight]="editCtaFontWeight">
      </common-order-status>
    </div>
  </div>
</div>
